// Storing part of the Currencies response which comes when global_configs API
// Todo: To replace this with a separate API for currencies only when it is created

export const currencies = [
  { type: "inr", name: "Indian Rupee", category: "fiat" },
  { type: "btc", name: "Bitcoin", category: "crypto" },
  { type: "xrp", name: "Ripple", category: "crypto" },
  { type: "ltc", name: "Litecoin", category: "crypto" },
  { type: "eth", name: "Ethereum", category: "crypto" },
  { type: "eos", name: "EOS", category: "crypto" },
  { type: "wrx", name: "WazirX Token", category: "crypto" },
  { type: "matic", name: "Matic Network", category: "crypto" },
  { type: "ada", name: "Cardano", category: "crypto" },
  { type: "bnb", name: "Binance Coin", category: "crypto" },
  { type: "doge", name: "Dogecoin", category: "crypto" },
  { type: "sxp", name: "Swipe", category: "crypto" },
];
